import { del, get, post } from "@/infra/rest";
import requestConfig from "@/shared/config/request";

const googleDriveBaseURL = requestConfig.baseUrl;

export interface GoogleDriveConnectResponse {
  authorize_url: string;
}

/** Returns URL for Google OAuth. Frontend redirects user to this URL. */
export const getGoogleDriveConnectUrl = async (): Promise<GoogleDriveConnectResponse> => {
  return get<GoogleDriveConnectResponse>({
    url: "/v0/integrations/google-drive/connect",
    config: { baseURL: googleDriveBaseURL },
    isAuthRequired: true,
    useCookies: true,
  });
};

export interface GoogleDriveStatusResponse {
  connected: boolean;
  /** Email of the Google account that granted OAuth token access (when connected). */
  user_email?: string;
  selected_folder?: {
    id: string;
    name?: string;
  };
}

/** Returns current user's Google Drive connection status. */
export const getGoogleDriveStatus = async (): Promise<GoogleDriveStatusResponse> => {
  return get<GoogleDriveStatusResponse>({
    url: "/v0/integrations/google-drive/status",
    config: { baseURL: googleDriveBaseURL },
    isAuthRequired: true,
    useCookies: true,
  });
};

/** Disconnects current user's Google Drive. Success is 204. */
export const disconnectGoogleDrive = async (): Promise<void> => {
  await del<void>({
    url: "/v0/integrations/google-drive/disconnect",
    config: { baseURL: googleDriveBaseURL },
    isAuthRequired: true,
    useCookies: true,
  });
};

export interface GoogleDriveAuthorizedResource {
  folder_id: string;
  file_ids: string[];
}

export interface SetGoogleDriveAuthorizedFilesPayload {
  authorized_resources: GoogleDriveAuthorizedResource[];
  mode: "ALL_FILES" | "SELECTED_FILES";
}

export const setGoogleDriveAuthorizedFiles = async (
  payload: SetGoogleDriveAuthorizedFilesPayload,
): Promise<void> => {
  await post<SetGoogleDriveAuthorizedFilesPayload, void>({
    url: "/v0/integrations/google-drive/authorized-files",
    data: payload,
    config: { baseURL: googleDriveBaseURL },
    isAuthRequired: true,
    useCookies: true,
  });
};
